import http from '../helpers/http';


export const getCurrentUser = async () => {
  try {
    const localData = JSON.parse(localStorage.getItem('currentUser'));
    const params = { userId: localData?.userId, sessionId: localData?.sessionId, instituteId: localData?.instituteId };
    const { data } = await http.get(`/api/users/current`, { params });
    return data;
  } catch (error) {
    localStorage.removeItem('currentUser');
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const getUser = async (id) => {
  try {
    const { data } = await http.get(`/api/users/${id}`);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const updateUser = async (id, payload) => {
  try {
    const { data } = await http.put(`/api/users/${id}`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const changePassword = async (payload) => {
  try {
    const { data } = await http.put(`/api/users/change-password`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const resetPassword = async (id, payload) => {
  try {
    const { data } = await http.put(`/api/users/${id}/reset-password`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const createInstituteUser = async (payload) => {
  try {
    const { data } = await http.post(`/api/users/institute`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const createBranchUser = async (payload) => {
  try {
    const { data } = await http.post(`/api/users/branch`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const getInstituteUsers = async (params) => {
  try {
    params = params || {};
    const config = { params };
    const { data } = await http.get(`/api/users/institute`, config);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const getBranchUsers = async (params) => {
  try {
    params = params || {};
    const config = { params };
    const { data } = await http.get(`/api/users/branch`, config);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const changeUserStatus = async (id) => {
  try {
    const { data } = await http.put(`/api/users/${id}/status`);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};
